var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7524 2.32255C16.2295 0.799715 14.2047 -0.0390625 12.0509 -0.0390625C9.89711 -0.0390625 7.87227 0.799715 6.34929 2.32255C3.67777 4.99406 3.27692 9.08907 5.14567 12.1884L0.681703 16.6524C-0.0739139 17.408 -0.0739139 18.6376 0.681703 19.3933C1.04776 19.7594 1.53452 19.961 2.05225 19.961C2.56983 19.961 3.05659 19.7594 3.42264 19.3933L7.88478 14.9311C9.12914 15.6847 10.559 16.0874 12.0509 16.0874C14.2047 16.0874 16.2295 15.2486 17.7525 13.7258C20.8963 10.5818 20.8963 5.46647 17.7524 2.32255ZM2.59348 18.5642C2.29502 18.8626 1.80933 18.8626 1.51087 18.5642C1.2124 18.2657 1.2124 17.78 1.51087 17.4816L5.83384 13.1586C5.99513 13.3538 6.16664 13.5431 6.34929 13.7258C6.53117 13.9077 6.72038 14.0795 6.916 14.2417L2.59348 18.5642ZM16.9233 12.8966C15.6218 14.1982 13.8914 14.9149 12.0509 14.9149C10.2102 14.9149 8.47987 14.1982 7.1783 12.8966C4.49168 10.21 4.49168 5.83833 7.1783 3.15171C8.47987 1.85028 10.2102 1.13343 12.0509 1.13343C13.8914 1.13343 15.6218 1.85028 16.9233 3.15171C19.61 5.83833 19.61 10.21 16.9233 12.8966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.0941 3.98145C15.0141 2.90143 13.5781 2.30664 12.0509 2.30664C10.5235 2.30664 9.08745 2.90143 8.00743 3.98145C5.77796 6.21091 5.77796 9.83855 8.00743 12.068C9.08745 13.148 10.5235 13.7428 12.0507 13.7428C13.5781 13.7428 15.014 13.148 16.094 12.068C18.3236 9.83855 18.3236 6.21091 16.0941 3.98145ZM15.265 11.239C14.4064 12.0975 13.265 12.5703 12.0509 12.5703C10.8367 12.5703 9.69505 12.0975 8.83659 11.239C7.06428 9.46669 7.06428 6.58292 8.83659 4.81061C9.6952 3.952 10.8367 3.47913 12.0509 3.47913C13.265 3.47913 14.4065 3.952 15.265 4.81061C16.1219 5.66755 16.5939 6.80906 16.5939 8.02473C16.594 9.24055 16.1221 10.3819 15.265 11.239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0759277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e9fc01a76f3bb9e777720b22f833ea7c.svg";
export { ForwardRef as ReactComponent };